export default __webpack_public_path__ + "static/media/Fingerprint.82ef223e.png";